import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function OurValues({
    global,
    pathPrefix,
    content,
    customClass = "",
    sub_heading_1,
    sub_heading_2,
    sub_heading_3,
    sub_heading_4,
    sub_heading_5,
    content_1,
    content_2,
    content_3,
    content_4,
    content_5,
    heading,
    imageSrc1,
    imageSrc2,
    imageSrc3,
    imageSrc4,
    imageSrc5,
    imageAlt1,
    imageAlt2,
    imageAlt3,
    imageAlt4,
    imageAlt5,
    urlSlug = false,
    displayOnDefault = false
}) {

    return (
        <>
            {urlSlug === "cpc-training" || displayOnDefault == true ?
                <section className={`${styles.root} ${customClass} text-center`} >
                    <Container>
                        {heading ?
                            <h2 className="text-center mb-4">
                                <SourceFlowText global={global} path={`${pathPrefix}.heading`}>{heading}</SourceFlowText>
                            </h2> : ""}
                        {content ?
                            <div className="text-center mb-5">
                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">{content}</SourceFlowText>
                            </div>
                            : ""}
                        <div className="content-wrapper rounded-3 p-4 p-md-5">
                            <Row>
                                {sub_heading_1 ?
                                    <Col sm={6} lg={3} className="position-relative mb-4">
                                        <Card className="rounded-3 overflow-hidden shadow h-100">
                                            <SourceFlowImage
                                                src={imageSrc1}
                                                size="1000x800"
                                                alt={imageAlt1}
                                                className="card-img rounded-0"
                                                width="100%"
                                                height="100%"
                                            />
                                            <CardBody className="p-4">
                                                <p><strong>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.sub_heading_1`}>{sub_heading_1}</SourceFlowText>
                                                </strong></p>
                                                <p>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.content_1`}>{content_1}</SourceFlowText>
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col> : ""}
                                {sub_heading_2 ?
                                    <Col sm={6} lg={3} className="position-relative mb-4">
                                        <Card className="rounded-3 overflow-hidden shadow h-100">
                                            <SourceFlowImage
                                                src={imageSrc2}
                                                size="1000x800"
                                                alt={imageAlt2}
                                                className="card-img rounded-0"
                                                width="100%"
                                                height="100%"
                                            />
                                            <CardBody className="p-4">
                                                <p><strong>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.sub_heading_2`}>{sub_heading_2}</SourceFlowText>
                                                </strong></p>
                                                <p>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.content_2`}>{content_2}</SourceFlowText>
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col> : ""}
                                {sub_heading_3 ?
                                    <Col sm={6} lg={3} className="position-relative mb-4">
                                        <Card className="rounded-3 overflow-hidden shadow h-100">
                                            <SourceFlowImage
                                                src={imageSrc3}
                                                size="1000x800"
                                                alt={imageAlt3}
                                                className="card-img rounded-0"
                                                width="100%"
                                                height="100%"
                                            />
                                            <CardBody className="p-4">
                                                <p><strong>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.sub_heading_3`}>{sub_heading_3}</SourceFlowText>
                                                </strong></p>
                                                <p>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.content_3`}>{content_3}</SourceFlowText>
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col> : ""}
                                {sub_heading_4 ?
                                    <Col sm={6} lg={3} className="position-relative mb-4">
                                        <Card className="rounded-3 overflow-hidden shadow h-100">
                                            <SourceFlowImage
                                                src={imageSrc4}
                                                size="1000x800"
                                                alt={imageAlt4}
                                                className="card-img rounded-0"
                                                width="100%"
                                                height="100%"
                                            />
                                            <CardBody className="p-4">
                                                <p><strong>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.sub_heading_4`}>{sub_heading_4}</SourceFlowText>
                                                </strong></p>
                                                <p>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.content_4`}>{content_4}</SourceFlowText>
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col> : ""}
                                {sub_heading_5 ?
                                    <Col sm={6} lg={3} className="position-relative mb-4">
                                        <Card className="rounded-3 overflow-hidden shadow h-100">
                                            <SourceFlowImage
                                                src={imageSrc5}
                                                size="1000x800"
                                                alt={imageAlt5}
                                                className="card-img rounded-0"
                                                width="100%"
                                                height="100%"
                                            />
                                            <CardBody className="p-4">
                                                <p><strong>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.sub_heading_5`}>{sub_heading_5}</SourceFlowText>
                                                </strong></p>
                                                <p>
                                                    <SourceFlowText global={global} path={`${pathPrefix}.content_5`}>{content_5}</SourceFlowText>
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col> : ""}
                            </Row>
                        </div>
                    </Container>
                </section> :
                ""
            }
        </>
    )
}